export type ReactionData = {
  reaction: string;
  count: number;
  currentUserReacted: boolean;
  otherUsersWhoReacted: string[];
  reactionShortName: string;
};

export const LIKE = '👍';
